import React, { useCallback, useRef, useState } from 'react';
import { useInView } from 'react-intersection-observer';
import { Container } from 'components/UI';
import { Title } from '@landing/ui';
import { Slider, SliderControl } from 'components/Slider';
import Slide from './Slide';

import * as styles from './Team.module.scss';

export default function Team({ title, slides }) {
  const [inViewRef, inView] = useInView({
    triggerOnce: true,
  });
  const sliderRef = useRef(null);
  const [current, setCurrent] = useState(1);

  const setCurrentIndex = useCallback((prev, next) => {
    setCurrent(next + 1);
  }, []);

  const handleNext = useCallback(() => {
    sliderRef.current.slickNext();
  }, [sliderRef]);

  const handlePrev = useCallback(() => {
    sliderRef.current.slickPrev();
  }, [sliderRef]);

  const settings = {
    fade: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    lazyLoad: 'progressive',
    arrows: false,
  };

  return (
    <Container id="team" className={styles.container} background="gray" theme="stairs">
      <div className={styles.layout}>
        <Title tag="h2">{title}</Title>
        <div className={styles.sliderWrapper} ref={inViewRef}>
          {inView && (
            <>
              <Slider
                ref={sliderRef}
                beforeChange={setCurrentIndex}
                className={styles.slider}
                {...settings}
              >
                {slides.map(slide => (
                  <Slide key={slide.name} {...slide} />
                ))}
              </Slider>
              {slides.length > 1 && (
                <SliderControl
                  className={styles.sliderControls}
                  current={current}
                  to={slides.length}
                  handleNext={handleNext}
                  handlePrev={handlePrev}
                />
              )}
            </>
          )}
        </div>
      </div>
    </Container>
  );
}
